import { State } from 'src/types'
import { fingerStand } from '../fingerStand'
import { beltStyleDrawer } from './beltStyleDrawer'
import { regularStyleDrawer } from './regularStyleDrawer'

export const backStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  fingerStand(ctx, state.fingerStand.color, state.stitch.color)
  // ベルトバックスタイル
  beltStyleDrawer(ctx, state)
  // レギュラーバックスタイル
  regularStyleDrawer(ctx, state)
}
